import { render } from "./SubmenuTopSites.vue?vue&type=template&id=312a16f6"
import script from "./SubmenuTopSites.vue?vue&type=script&lang=js"
export * from "./SubmenuTopSites.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__